import { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../../actions'
import { Button, Container, Header, Icon, Segment } from 'semantic-ui-react'

import ReportCaseCreateCoreSection from './sections/ReportCaseCreateCoreSection'
import { deriveReportCaseStatus } from '../../../utilities/reportCaseStatus'

class NewReportCase extends Component {
    state = {
        clientId: '',

        companyName: '',
        status: 'pending_assign',

        emailReceivedOn: '',
        personInCharge: '',
        reportTypes: [],
        customReportType: '',
        xbrlService: false,
        fye: '',
        instructions: '',

        dueDate: '',
        nextFollowUpDate: '',
        isUrgent: false,

        totalOutstanding: '',
        paymentRemark: '',
        workflowCompleted: false,
        
        deliverySigningStatus: 'pending_document',
        deliverySigningRemarks: '',

        submitting: false
    }

    componentDidMount() {
        this.props.fetchReportCaseAssignees()

        if (this.props.prefill) {
            const p = this.props.prefill
            this.setState({
                clientId: p.clientId || '',
                companyName: p.companyName || '',
                personInCharge: p.personInCharge || ''
            })
        }
    }

    setField = (field, value) => {
        this.setState({ [field]: value })
    }

    canSubmit() {
        return !!String(this.state.companyName || '').trim()
    }

    handleCreate = async () => {
        if (!this.canSubmit()) return
        if (this.state.submitting) return

        this.setState({ submitting: true })

        try {
            const nextStatus = deriveReportCaseStatus(this.state.status, {
                workflowCompleted: this.state.workflowCompleted,
                personInCharge: this.state.personInCharge,
                sentToClientDate: this.state.sentToClientDate,
                signedReceivedDate: this.state.signedReceivedDate,
                totalOutstanding: this.state.totalOutstanding
            })

            const payload = {
                clientId: emptyToNull(this.state.clientId),

                companyName: String(this.state.companyName || '').trim(),
                status: nextStatus,
                workflowCompleted: !!this.state.workflowCompleted,

                emailReceivedOn: emptyToNull(this.state.emailReceivedOn),
                personInCharge: emptyToNull(this.state.personInCharge),

                reportTypes: Array.isArray(this.state.reportTypes) ? this.state.reportTypes : [],
                customReportType: (this.state.customReportType || '').trim() || null,
                xbrlService: !!this.state.xbrlService,
                fye: this.state.fye,
                instructions: this.state.instructions,

                dueDate: emptyToNull(this.state.dueDate),
                nextFollowUpDate: emptyToNull(this.state.nextFollowUpDate),
                isUrgent: emptyToNull(this.state.isUrgent),

                totalOutstanding: toNumberOrNull(this.state.totalOutstanding),
                paymentRemark: this.state.paymentRemark,

                deliverySigningStatus: this.state.deliverySigningStatus || 'pending_document',
                deliverySigningRemarks: (this.state.deliverySigningRemarks || '').trim()
            }

            await this.props.createReportCase(payload)
            this.props.onCreateSuccess()
        } finally {
            this.setState({ submitting: false })
        }
    }

    render() {
        return (
            <Container style={{ paddingTop: 20, paddingBottom: 40 }}>
                <Segment>
                    <Button basic icon labelPosition='left' onClick={this.props.onCancel}>
                        <Icon name='arrow left' />
                        Back
                    </Button>

                    <Header as='h2' style={{ marginTop: 14 }}>
                        New Workflow
                        <Header.Subheader>
                            Create a new workflow and assign a PIC. You can fill the rest later.
                        </Header.Subheader>
                    </Header>

                    <ReportCaseCreateCoreSection
                        values={this.state}
                        users={this.props.reportCaseAssignees}
                        onChange={this.setField}
                        onSubmit={this.handleCreate}
                    />

                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 12 }}>
                        <Button basic onClick={this.props.onCancel} disabled={this.state.submitting}>
                            Cancel
                        </Button>
                        <Button
                            primary
                            onClick={this.handleCreate}
                            loading={this.state.submitting}
                            disabled={!this.canSubmit() || this.state.submitting}
                        >
                            Create
                        </Button>
                    </div>
                </Segment>
            </Container>
        )
    }
}

function emptyToNull(v) {
    if (v === '') return null
    return v
}

function toNumberOrNull(v) {
    if (v === '' || v == null) return null
    const n = Number(v)
    return Number.isFinite(n) ? n : null
}

function mapStateToProps({ reportCaseAssignees }) {
    return { reportCaseAssignees }
}

export default connect(mapStateToProps, actions)(NewReportCase)
